import React, { useMemo } from 'react';
import MuiTable from '@components/table/table';
import { Box, Skeleton } from '@mui/material';

const renderCell = () => {
  return (
    <Box width="200px">
      <Skeleton width="100%" height="40px" />
    </Box>
  );
};

const renderHeader = renderCell;

function TableSkeleton({
  paddingLeft,
  paddingRight,
  marginBottom = 0,
  COLUMNS_COUNT = 10,
  ROWS_COUNT = 10,
  hideFooter = true,
  noBorder = false,
  height = '100%',
  width = 200,
  tableWidth = '100%',
  skeletonRowHeight = 49.9,
}) {
  // PERF: Memoize to avoid rebuilding arrays on every render
  const columns = useMemo(
    () =>
      Array.from(new Array(COLUMNS_COUNT)).map((_, index) => ({ field: `skeleton-${index}`, renderHeader, renderCell, width })),
    [COLUMNS_COUNT, width],
  );
  const rows = useMemo(
    () => Array.from(new Array(ROWS_COUNT)).map((_, index) => ({ id: index })),
    [ROWS_COUNT],
  );

  return (
    <Box
      height={height}
      width={tableWidth}
      paddingLeft={paddingLeft || 0}
      paddingRight={paddingRight || 0}
      marginBottom={marginBottom || 0}
      paddingBottom="15px">
      <MuiTable
        columns={columns}
        rows={rows}
        pagination={false}
        hideFooter={hideFooter}
        noBorder={noBorder}
        rowHeight={skeletonRowHeight}
      />
    </Box>
  );
}

export default React.memo(TableSkeleton);
